import type { DetectedClient, DetectedClientResponse, UploadedFile } from './types';

export function mapDetectedClients(
  detectedClients: DetectedClientResponse[] | null | undefined,
): DetectedClient[] {
  return (detectedClients ?? []).map(detected => ({
    id: detected.client.id,
    firstName: detected.client.firstName,
    lastName: detected.client.lastName,
    isProcessed: detected.isProcessed ?? false,
  }));
}

export const hasDetectionFor = (file: UploadedFile, clientId: string | undefined) =>
  !!clientId && file.detectedClients.some(detected => detected.id === clientId);

export const isFamilyMembersFile = (file: UploadedFile, clientId: string | undefined) =>
  !!file.clientId && file.clientId !== clientId;
